import React, { createContext, useContext } from 'react';

interface BasePathContextValue {
  basePath: string; // '/parent' 或 '/teach'
}

const BasePathContext = createContext<BasePathContextValue>({ basePath: '/teach' });

export const BasePathProvider: React.FC<{ basePath: string; children: React.ReactNode }> = ({
  basePath,
  children,
}) => {
  return (
    <BasePathContext.Provider value={{ basePath }}>
      {children}
    </BasePathContext.Provider>
  );
};

export const useBasePath = (): BasePathContextValue => {
  return useContext(BasePathContext);
};
